import Header from './components/Header';
import Footer from './components/Footer';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function DPUCalculator() {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dpu_calculator');
    const [calcObj, setCalcObj] = useState({
        step: locale === 'ca' ? 2 : 1,
        check1: locale === 'ca' ? 1 : 0,
        selected: [],
        selectedText: '',
        apps: [],
        totalPower: 0,
        totalWatt: 0,
        dpuNum: 0,
        ebNum: 0,
        checkB: 1,
        peakCharges: '',
        offpeakCharges: '',
        bill: '',
        extend: [],
        remove: false,
    });

    return (
        <div className={`dpu-calculator ${css['dpu-calculator']}`}>
            <Header calcObj={calcObj} />
            <>
                {calcObj.step === 1 && <Step1 calcObj={calcObj} callback={setCalcObj} />}
                {calcObj.step === 2 && (
                    <Step2
                        calcObj={calcObj}
                        callback={(e) => {
                            console.log('1', e);
                            setCalcObj(e);
                        }}
                    />
                )}
                {calcObj.step === 3 && <Step3 calcObj={calcObj} callback={setCalcObj} />}
            </>
            <Footer calcObj={calcObj} callback={setCalcObj} />
            <style jsx global>
                {`
                    .ecoflow-frame-main {
                        background-color: #f5f5f5;
                    }
                `}
            </style>
        </div>
    );
}
